const mapStateToThis = ({ config }) => {
  const { phoneMask } = config;

  return {
    phoneMask,
  };
};

const mapDispatchToThis = {};

@Inject('$ngRedux')
export class RwPhoneController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onDestroy() {
    this.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/rw-phone/rw-phone-controller.js